import React from "react";
import { useTranslation } from "react-i18next";
import "./NonDev.css";

function NonDev() {
  const { t } = useTranslation();
  return (
    <div className="non-dev">
      <h1>{t("nonDev.title")}</h1>
      <p className="non-dev-intro">
        {t("nonDev.intro")}
      </p>

      <section className="non-dev-section">
        <h2>{t("nonDev.satochipTitle")}</h2>
        <p>
          <a
            href="https://satochip.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="satochip-link"
          >
            Satochip
          </a>{" "}
          {t("nonDev.satochipDesc1")}
        </p>
        <p>
          {t("nonDev.satochipDesc2")}
        </p>
      </section>

      <section className="non-dev-section">
        <h2>{t("nonDev.overviewTitle")}</h2>
        <p>
          {t("nonDev.overviewDesc")}
        </p>
      </section>

      <section className="non-dev-section coming-soon">
        <h2>📝 {t("nonDev.comingSoonTitle")}</h2>
        <p>
          {t("nonDev.comingSoonDesc")}
        </p>
        <ol className="steps-list">
          <li>{t("nonDev.comingSoonStep1")}</li>
          <li>{t("nonDev.comingSoonStep2")}</li>
          <li>{t("nonDev.comingSoonStep3")}</li>
          <li>{t("nonDev.comingSoonStep4")}</li>
          <li>{t("nonDev.comingSoonStep5")}</li>
          <li>{t("nonDev.comingSoonStep6")}</li>
        </ol>
        <p className="coming-soon-note">
          {t("nonDev.comingSoonNote")}
        </p>
      </section>
    </div>
  );
}

export default NonDev;

